import React from "react";

function NewTool({ text = "NEW TOOL" }) {
  return (
    <span
      className="badge fw-400 text-white text-sm shadow"
      style={{
        background: "linear-gradient(92.29deg, #FFA24E 3.42%, #FFA58B 47.69%, #FF8FBC 97.86%)",
      }}
    >
      {text}
    </span>
  );
}
export default NewTool;
